module.exports = __webpack_public_path__ + "img/Marta_Palinska.d2fb2fb9.jpg";